import defaultConfig from '.';

export default {
  ...defaultConfig,
  loadGDPRScript: true,
  pageOpts: {
    ...defaultConfig.pageOpts,
    keywords: {
      'no-sno-publishergroup': 'schibsted',
    },
  },
};
